import React from 'react';
export const createMarkup = html => {
    return {__html: html};
};

export const ComponentWithHTML = ({component: Component, html}) => {
    return <Component dangerouslySetInnerHTML={createMarkup(html)} />;
};
